const checkLogin = function(bypass) {
  let data = $('form').serialize();
  data = bypass ? `${data}&bypass=true` : data;

  $.ajax({
    url: '/ajax/test/login',
    type: 'POST',
    dataType: 'json',
    data,
  })
    .done(response => {
      if (!response.err) {
        if (slug) {
          window.location.href = `/${slug}`;
        }
        else {
          window.location.reload();
        }
      }
      else {
        $('.error').html(response.msg);
        $('.btn-submit').prop('disabled', false);
      }
    })
    .fail(() => {
      $('.btn-submit').prop('disabled', false);
    });

  return false;
};

_validator = $('#login-form').validate({
  ignore: [],
  onfocusout(element) {
    $(element).valid();
  },
  rules: {
    username: {
      required: true,
    },
    password: {
      required: true,
    },
  },
  messages: {
    username: {
      required: 'Username is required.',
    },
    password: {
      required: 'Password is required.',
    },
  },
  highlight(element) {
    $(element).closest('div').addClass('error').removeClass('valid');
  },
  unhighlight(element) {
    $(element).closest('div').removeClass('error').addClass('valid');
  },
  errorPlacement(error, element) {
    const message = error.html();

    if (message.length > 0) {
      $(element[0]).closest('div.error').append(error);
    }
  },
  // ---------------------------------------------------- FORM SUBMIT HANDLER //
  submitHandler() {
    $('.btn-submit').prop('disabled', true);

    checkLogin();
  },
});
